import { render, staticRenderFns } from "./CiInfoBox.vue?vue&type=template&id=3bc1c36d&scoped=true&"
import script from "./CiInfoBox.vue?vue&type=script&lang=js&"
export * from "./CiInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./CiInfoBox.vue?vue&type=style&index=0&id=3bc1c36d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1c36d",
  null
  
)

component.options.__file = "CiInfoBox.vue"
export default component.exports